"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostMaintenanceStartRequest = instanceOfApiPostMaintenanceStartRequest;
exports.ApiPostMaintenanceStartRequestFromJSON = ApiPostMaintenanceStartRequestFromJSON;
exports.ApiPostMaintenanceStartRequestFromJSONTyped = ApiPostMaintenanceStartRequestFromJSONTyped;
exports.ApiPostMaintenanceStartRequestToJSON = ApiPostMaintenanceStartRequestToJSON;
exports.ApiPostMaintenanceStartRequestToJSONTyped = ApiPostMaintenanceStartRequestToJSONTyped;
/**
 * Check if a given object implements the ApiPostMaintenanceStartRequest interface.
 */
function instanceOfApiPostMaintenanceStartRequest(value) {
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    return true;
}
function ApiPostMaintenanceStartRequestFromJSON(json) {
    return ApiPostMaintenanceStartRequestFromJSONTyped(json, false);
}
function ApiPostMaintenanceStartRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startTime': (new Date(json['start_time'])),
        'endTime': (new Date(json['end_time'])),
    };
}
function ApiPostMaintenanceStartRequestToJSON(json) {
    return ApiPostMaintenanceStartRequestToJSONTyped(json, false);
}
function ApiPostMaintenanceStartRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'start_time': ((value['startTime']).toISOString()),
        'end_time': ((value['endTime']).toISOString()),
    };
}
